import { cache as defaultCache } from "apollo/client";
import defaults from "state/defaults";

export const clearState = (cache = defaultCache) => {
  cache.writeData({
    data: {
      ...defaults,
    },
  });
};

export default clearState;



// WEBPACK FOOTER //
// ./src/utils/clearState.js